module.exports = __webpack_public_path__ + "static/media/1_P Eric Lui -min.389e70b3.jpg";